export class SimpleModal {
	constructor(modal_element) {
		let modal_class = modal_element.className.split(' ')[0];
		let modal_id = modal_element.id;
		let exit_button_selector = '.modal_content > .exit_button';
		let main_button_selector = '.modal_content > .main_button';
		this.modal_element = modal_element;
		this.modal_overlay = document.getElementById(`${modal_class}_overlay`);
		this.modal_exit_button =
			document.querySelector(`#${modal_id} > ${exit_button_selector}`);
		this.modal_main_button =
			document.querySelector(`#${modal_id} > ${main_button_selector}`);
		this.generate_modal();
		this.call_modal();
		this.trigger_main_button();
		this.trigger_overlay_exit();
	}

	generate_modal() {
		this.modal_overlay.append(this.modal_element);
	}

	trigger_overlay_exit() {
		[this.modal_overlay, this.modal_exit_button].forEach(
			element => {
				if (element) {
					element.addEventListener('click', () => {
						this.toggle_overlay();
					});
				}
			}
		);
	}

	trigger_main_button() {
		this.modal_main_button.addEventListener('click', () => {
			this.toggle_overlay();
		});
	}

	toggle_overlay() {
		[this.modal_overlay, this.modal_element].forEach(
			element => element.classList.toggle('hidden')
		);
		document.body.classList.toggle('unscrollable');
	}

	call_modal() {
		this.toggle_overlay();
		this.modal_element.addEventListener('click', element => {
			element.stopPropagation();
		});
	}
}